<form [formGroup]="rangeGroup" class="mb-8">
  <app-radio-group-range-type
    formControlName="rangeType"
  ></app-radio-group-range-type>
  <app-select-date-range-type
    formControlName="dateRange"
    [selectDatesText]="selectDatesText"
    [isFocused]="rangeGroup.value.rangeType"
  ></app-select-date-range-type>
</form>
